
const WHATSAPP_NUMERO = '593979044368';
const WHATSAPP_DISPLAY = '+593 979 044 368';

const Contact = {
  WHATSAPP_NUMERO,
  WHATSAPP_DISPLAY,
};

export default Contact;
